export default __webpack_public_path__ + "static/media/8-20_Gs.298b06ae.svg";